import React from 'react';
type TextImageRowProps = {
  id: string;
  eyebrow?: string;
  title: string;
  paragraphs: string[];
  image: {
    src: string;
    alt: string;
  };
  reverse?: boolean;
  tone?: 'white' | 'warm';
  note?: React.ReactNode;
};
export function TextImageRow({
  id,
  eyebrow,
  title,
  paragraphs,
  image,
  reverse,
  tone = 'white',
  note
}: TextImageRowProps) {
  return <section className={`w-full py-20 ${tone === 'warm' ? 'bg-canvas-warm' : 'bg-white'}`} aria-labelledby={id} data-id="element-366" data-mp="1bxqng5t9n6i9">
      <div className="mx-auto grid max-w-shell grid-cols-1 items-center gap-10 px-6 lg:grid-cols-2 lg:gap-16" data-id="element-367" data-mp="29hblnjef0pdz">
        <div className={reverse ? 'lg:order-2' : ''} data-id="element-368" data-mp="1zlhy74z5rbhf">
          {eyebrow && <p className="text-[14px] font-semibold text-brand" data-id="element-369" data-mp="1zjorxqsgit9y">{eyebrow}</p>}
          <h2 id={id} className="display mt-3 text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-370" data-mp="1viv6r56efskr">
            {title}
          </h2>
          <div className="mt-6 max-w-[520px] space-y-4" data-id="element-371" data-mp="o48gamvogri8">
            {paragraphs.map(p => <p key={p} className="text-[16px] leading-[1.65] text-ink-muted" data-id="element-372" data-mp="k6ubd7f155w1">
                {p}
              </p>)}
          </div>
          {note && <div className="mt-6 max-w-[520px]" data-id="element-373" data-mp="1moxvzt7lpy8m">{note}</div>}
        </div>
        <img src={image.src} alt={image.alt} loading="lazy" className={`h-[300px] w-full rounded-[14px] object-cover sm:h-[420px] ${reverse ? 'lg:order-1' : ''}`} data-id="element-374" data-mp="18p6psenbtm56" />
      </div>
    </section>;
}